import React, { useMemo } from 'react';
import { ReportingContainerBaseConfig } from '../../../../base';
import { FieldItemController } from './fieldItemInterface';
import { FieldItemContainerProps } from './fieldItemProps';

export function createFieldItemContainer(
    config: ReportingContainerBaseConfig,
    controller: FieldItemController
): React.FC<FieldItemContainerProps> {
    return ({ as: View, ...containerProps }) => {
        const titleInputRef = React.useRef<HTMLInputElement>(null);

        // Auto-focus when this is a new field (no title set)
        React.useEffect(() => {
            if (!containerProps.value.title && titleInputRef.current) {
                // Small delay to ensure DOM is ready
                const timeoutId = setTimeout(() => {
                    titleInputRef.current?.focus();
                }, 50);
                return () => clearTimeout(timeoutId);
            }
        }, [containerProps.value.title]);

        // Create minimal aggregate needed by controller
        const aggregate = useMemo(
            () => ({
                state: containerProps.value,
            }),
            [containerProps.value]
        );

        const props = controller.useProps(aggregate, {
            titleInputRef,
            ...containerProps,
        });

        return <View {...props} />;
    };
}
